import { appLocalStorage } from 'utils/misc'
import { LOCAL_STORAGE_APP_CONTEXT_DATA_VAR_NAME } from 'utils/constants'

export const LOCAL_STORAGE_APP_STATE = appLocalStorage.getValue(LOCAL_STORAGE_APP_CONTEXT_DATA_VAR_NAME)

export enum SORT_DIRECTION {
  ASC = 'ASC',
  DESC = 'DESC'
}
